import { render } from "./enrolment-export-modal.vue?vue&type=template&id=009cedf6&ts=true"
import script from "./enrolment-export-modal.ts?vue&type=script&lang=ts&external"
export * from "./enrolment-export-modal.ts?vue&type=script&lang=ts&external"

import "./enrolment-export-modal.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__